import clsx from "clsx";
import Container from "./Container";

export default function ScrollProgressBar({
  progress,
  scrollClass,
}: {
  progress: number;
  scrollClass?: string;
}) {
  return (
    <Container containerClass={clsx("w-full mt-10", scrollClass)}>
      <div className="h-1 w-full rounded-l-md rounded-r-md bg-black/20">
        <div
          className="h-full rounded-l-md rounded-r-md bg-black"
          style={{
            width: `${progress}%`,
          }}
        ></div>
      </div>
    </Container>
  );
}
